export { default } from './HostedEvents';
